module Shared.Admin.UserGrid
open System

let [<Literal>] PAGE_SIZE = 40

type UserDTO = 
    {
        Id: int 
        Forename: string 
        Surname: string 
        Username: string
        Email: string
        LockedReason: string option
        DisabledReason: string option
    }

type PageNo = PageNo of int 
module PageNo = 
    let unwrap = function PageNo x -> x
    let map mapper = function PageNo x -> mapper x |> PageNo
    let increment = map (fun x -> x + 1)

type SearchString = SearchString of string 
module SearchString = 
    let toString (SearchString str) = if String.IsNullOrWhiteSpace str then None else Some str
    let isEmpty (SearchString str) = String.IsNullOrEmpty str
    let empty = SearchString ""

type SortField =
    | FullName
    | Username
    | Email

type SortDirection =
    | Asc
    | Desc

module SortDirection =
    let toggle =
        function
        | Asc -> Desc
        | Desc -> Asc

type SortInfo =
    {
        Field: SortField
        Direction: SortDirection
    }

module SortInfo =
    let defaults =
        {
            Field = FullName
            Direction = Asc
        }

type IncludeUsersFilter = 
    {
        Locked: bool 
        Unlocked: bool 
        Disabled: bool 
        Enabled: bool
        Tags: Guid Set
    }

module IncludeUsersFilter = 
    let all = 
        {
            Locked = true
            Unlocked = true
            Disabled = true
            Enabled = true
            Tags = Set.empty
        }